var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadTitle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.9993 22.6793H36.5975V52.8847C36.5975 53.2776 36.9189 53.599 37.3118 53.599H42.669C43.0618 53.599 43.3832 53.2776 43.3832 52.8847V22.6793H49.9993C50.5975 22.6793 50.9279 21.9918 50.5618 21.5275L40.5618 8.86683C40.495 8.78146 40.4096 8.71242 40.3122 8.66493C40.2147 8.61745 40.1077 8.59277 39.9993 8.59277C39.8909 8.59277 39.7839 8.61745 39.6865 8.66493C39.589 8.71242 39.5036 8.78146 39.4368 8.86683L29.4368 21.5186C29.0707 21.9918 29.4011 22.6793 29.9993 22.6793ZM72.6779 50.2061H67.3207C66.9279 50.2061 66.6065 50.5276 66.6065 50.9204V64.6704H13.3922V50.9204C13.3922 50.5276 13.0707 50.2061 12.6779 50.2061H7.32073C6.92787 50.2061 6.60645 50.5276 6.60645 50.9204V68.599C6.60645 70.1793 7.88323 71.4561 9.46359 71.4561H70.535C72.1154 71.4561 73.3922 70.1793 73.3922 68.599V50.9204C73.3922 50.5276 73.0707 50.2061 72.6779 50.2061Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadTitle);
export default __webpack_public_path__ + "static/media/UploadTitle.9577dd764fa19e4853fb76a274bc81c8.svg";
export { ForwardRef as ReactComponent };